<template>
  <div class="multi-net-unpack-page">
    <!-- 空状态 -->
    <div v-if="cardList.length === 0" class="empty-state">
      <i class="el-icon-unlock empty-icon"></i>
      <p class="empty-title">组网批量拆网 · 暂无待处理组网号</p>
      <p class="empty-desc">
        在下方添加需要拆网的组网号,系统会同时列出当前移动/电信卡号,您在表格里勾选要拆的运营商即可。
        <br />每个组网号可以单独勾选:仅拆移动、仅拆电信、或两个都拆。
      </p>
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="openAddDialog">
        添加组网号
      </el-button>
    </div>

    <!-- 顶部说明条 -->
    <div v-else class="page-body">
      <div class="page-header">
        <div class="header-text">
          <div class="page-title">
            <i class="el-icon-unlock title-icon"></i>
            组网批量拆网
          </div>
          <div class="page-subtitle">
            支持同时处理多个组网号,组网号本身保持不变,仅解除组网下勾选运营商(移动/电信)的绑定关系。
            <span class="text-muted">未勾选的运营商卡保留在组网中继续使用。</span>
          </div>
        </div>
        <div class="header-actions">
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="openAddDialog">
            添加组网号
          </el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :data="cardList"
        border
        stripe
        v-loading="pageLoading"
        class="data-table"
        :row-class-name="rowClassName"
        size="small"
      >
        <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
        <el-table-column prop="groupNo" label="组网号" align="center" width="150">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.groupNo"
              type="primary"
              :underline="false"
              @click="goGroupDetail(scope.row.groupNo)"
            >
              {{ scope.row.groupNo }}
            </el-link>
            <span v-else class="placeholder">--</span>
          </template>
        </el-table-column>
        <el-table-column label="原移动卡" align="center" min-width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-if="scope.row.ydIccid" class="op-row">
              <i class="op-icon op-icon-mobile"></i>
              <el-link
                type="primary"
                :underline="false"
                @click="goCardDetail(scope.row.ydIccid)"
              >
                {{ scope.row.ydIccid }}
              </el-link>
            </div>
            <span v-else class="placeholder">无</span>
          </template>
        </el-table-column>
        <el-table-column label="原电信卡" align="center" min-width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-if="scope.row.dxIccid" class="op-row">
              <i class="op-icon op-icon-telecom"></i>
              <el-link
                type="primary"
                :underline="false"
                @click="goCardDetail(scope.row.dxIccid)"
              >
                {{ scope.row.dxIccid }}
              </el-link>
            </div>
            <span v-else class="placeholder">无</span>
          </template>
        </el-table-column>
        <el-table-column label="拆移动" align="center" width="110">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.unpackYd"
              :disabled="!scope.row.ydIccid"
              @change="onCheckChange(scope.row)"
            >拆移动</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="拆电信" align="center" width="110">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.unpackDx"
              :disabled="!scope.row.dxIccid"
              @change="onCheckChange(scope.row)"
            >拆电信</el-checkbox>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="remark" label="备注" align="center" min-width="180">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              placeholder="选填"
              size="small"
              clearable
              maxlength="100"
            ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="danger-text-btn"
              icon="el-icon-delete"
              @click="removeItem(scope.row, scope.$index)"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="add-card-bar">
        <el-button type="primary" plain icon="el-icon-circle-plus-outline" style="width: 100%" @click="openAddDialog">
          添加组网号
        </el-button>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="page-footer" v-if="cardList.length > 0">
      <div class="footer-summary">
        <span>待处理组网号:<strong>{{ cardList.length }}</strong> 个</span>
        <span class="text-muted">
          已选拆移动:<strong>{{ summary.yd }}</strong>
        </span>
        <span class="text-muted">
          已选拆电信:<strong>{{ summary.dx }}</strong>
        </span>
        <span :class="{ 'text-warn': invalidCount > 0 }">
          待修正条目:<strong>{{ invalidCount }}</strong>
        </span>
      </div>
      <div class="footer-buttons">
        <el-button icon="el-icon-refresh-left" @click="handleClear">清空全部</el-button>
        <el-button
          type="primary"
          size="medium"
          :loading="submitLoading"
          :disabled="!canSubmit"
          @click="submitUnpack"
        >提交批量拆网</el-button>
      </div>
    </div>

    <!-- 添加组网号弹窗 -->
    <el-dialog
      title="添加组网号"
      :visible.sync="addDialogVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      @close="resetAddDialog"
    >
      <el-form :model="addForm" ref="addFormRef" :rules="addFormRules" label-width="0">
        <el-form-item prop="groupNos">
          <el-input
            v-model="addForm.groupNos"
            type="textarea"
            :rows="8"
            placeholder="支持批量粘贴,每行/逗号分隔一个组网号"
          ></el-input>
        </el-form-item>
        <div class="add-stat">
          已识别 <strong>{{ addRowCount }}</strong> 个组网号,
          排除重复后新增 <strong>{{ newAddCount }}</strong> 个
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="confirmAddGroupNos">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectMultiNetByGroupNos, batchUnpackCardMultiCard, unpackCardMultiCard } from '@/api/multiNet'

export default {
  name: 'multiNetUnpack',
  data() {
    return {
      pageLoading: false,
      submitLoading: false,
      addLoading: false,
      cardList: [],

      // 校验状态外置:{ groupNo: errorMsg }
      errorMap: {},

      // 添加组网号弹窗
      addDialogVisible: false,
      addForm: {
        groupNos: ''
      },
      addFormRules: {
        groupNos: [
          { required: true, message: '请输入组网号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 解析后的输入(行/逗号/空格/分号)
    parsedGroupNos() {
      if (!this.addForm.groupNos) return []
      return this.addForm.groupNos
        .split(/[\n,;，；\s]+/)
        .map(s => s.trim())
        .filter(s => !!s)
    },
    // 已识别总数
    addRowCount() {
      return this.parsedGroupNos.length
    },
    // 排除已存在的数量
    newAddCount() {
      const existed = this.cardList.map(c => c.groupNo)
      return this.parsedGroupNos.filter(g => !existed.includes(g)).length
    },
    // 无效条数(从 errorMap 取,响应式)
    invalidCount() {
      return Object.keys(this.errorMap).length
    },
    // 汇总:勾选了拆移动 / 拆电信的总数
    summary() {
      return this.cardList.reduce((acc, item) => {
        if (item.unpackYd) acc.yd += 1
        if (item.unpackDx) acc.dx += 1
        return acc
      }, { yd: 0, dx: 0 })
    },
    // 已勾选任意运营商的组网号总数
    pickedCount() {
      return this.cardList.filter(c => c.unpackYd || c.unpackDx).length
    },
    // 提交按钮是否可点:列表非空 + 无无效 + 至少一条勾选了运营商
    canSubmit() {
      return this.cardList.length > 0
        && this.invalidCount === 0
        && this.pickedCount > 0
    }
  },
  created() {
    this.initCards()
  },
  methods: {
    initCards() {
      const fromParams = (this.$route.params && this.$route.params.iccids) || ''
      if (!fromParams) return
      const list = fromParams.split(/[\n,;，；\s]+/).map(s => s.trim()).filter(s => !!s)
      if (list.length === 0) return
      this.loadGroupNos(list)
    },

    /**
     * 添加组网号(去重 → 拉详情 → 装配行)
     * 与 switch/index.vue 中的实现保持一致
     */
    loadGroupNos(groupNos) {
      const existed = this.cardList.map(c => c.groupNo)
      const newOnes = groupNos.filter(g => !existed.includes(g))
      if (newOnes.length === 0) {
        const dup = groupNos.join(', ')
        this.$message.warning(`这 ${groupNos.length} 个组网号已在列表中,无需重复添加(${dup})`)
        return
      }
      const skipped = groupNos.filter(g => existed.includes(g))
      this.pageLoading = true
      selectMultiNetByGroupNos(newOnes).then(res => {
        if (res.data.code === 200) {
          const rows = (res.data.data || []).filter(r => r && r.groupNo)
          if (rows.length === 0) {
            this.$message.warning(`以下组网号加载失败或不存在: ${newOnes.join(', ')}`)
            return
          }
          // 装配默认勾选状态:
          //   - 默认两个运营商都不勾选,由用户主动勾选要拆哪些
          //   - 没有对应运营商卡号时,对应勾选框 disabled
          const mounted = rows.map(r => ({
            ...r,
            // 兼容后端字段命名:ydIccid / dxIccid
            ydIccid: r.ydIccid || '',
            dxIccid: r.dxIccid || '',
            unpackYd: false,
            unpackDx: false,
            remark: ''
          }))
          this.cardList = [...this.cardList, ...mounted]
          this.cardList.forEach(item => this.validateItem(item))
          if (newOnes.length > rows.length) {
            this.$message.warning(`部分组网号加载失败: ${newOnes.slice(rows.length).join(', ')}`)
          }
          if (skipped.length > 0) {
            this.$message.info(`已跳过 ${skipped.length} 个已存在的组网号`)
          }
        } else {
          this.$message.warning(`以下组网号加载失败或不存在: ${newOnes.join(', ')}`)
        }
      })
      .finally(() => {
        this.pageLoading = false
      })
    },

    /**
     * 校验单行:至少勾选一个运营商
     */
    validateItem(item) {
      if (!item || !item.groupNo) return true
      const { ydIccid, dxIccid, unpackYd, unpackDx } = item
      let msg = ''
      if (!unpackYd && !unpackDx) {
        msg = '至少勾选一项要拆的运营商(移动/电信)'
      } else if (unpackYd && !ydIccid) {
        msg = '该组网号没有移动卡,不可勾选拆移动'
      } else if (unpackDx && !dxIccid) {
        msg = '该组网号没有电信卡,不可勾选拆电信'
      }
      if (msg) {
        this.$set(this.errorMap, item.groupNo, msg)
      } else {
        this.$delete(this.errorMap, item.groupNo)
      }
      return !msg
    },

    /**
     * 复选框变化时实时校验
     */
    onCheckChange(item) {
      this.validateItem(item)
    },

    /**
     * 打开添加组网号
     */
    openAddDialog() {
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate()
      })
    },

    /**
     * 重置添加弹窗
     */
    resetAddDialog() {
      this.addForm.groupNos = ''
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
    },

    /**
     * 确认添加组网号
     */
    confirmAddGroupNos() {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        const list = this.parsedGroupNos
        if (list.length === 0) {
          this.$message.warning('请输入有效的组网号')
          return
        }
        this.addLoading = true
        this.loadGroupNos(list)
        setTimeout(() => {
          this.addLoading = false
          this.addDialogVisible = false
        }, 600)
      })
    },

    /**
     * 移除单行
     */
    removeItem(item, index) {
      this.$confirm(`确定移除组网号 ${item.groupNo} 的拆网记录?`, '移除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.cardList.splice(index, 1)
          this.$delete(this.errorMap, item.groupNo)
          this.$message.success('移除成功')
        })
        .catch(() => {})
    },

    /**
     * 清空全部
     */
    handleClear() {
      if (this.cardList.length === 0) return
      this.$confirm('确认清空所有拆网条目?', '清空确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.cardList = []
        this.errorMap = {}
      })
      .catch(() => {})
    },

    /**
     * 提交批量拆网
     * - 优先调用批量接口 batchUnpackCardMultiCard (后端可一次性处理)
     */
    submitUnpack() {
      // 重新校验全部
      let hasError = false
      this.cardList.forEach(item => {
        if (!this.validateItem(item)) hasError = true
      })
      if (hasError) {
        this.$message.warning('请先修正标红条目')
        return
      }
      const ready = this.cardList.filter(c => c.unpackYd || c.unpackDx)
      if (ready.length === 0) {
        this.$message.warning('请至少勾选一项要拆的运营商')
        return
      }
      const ydCount = ready.filter(c => c.unpackYd).length
      const dxCount = ready.filter(c => c.unpackDx).length
      const desc = [
        `待处理组网号:<strong>${ready.length}</strong> 个`
      ].join('<br/>')
      this.$confirm(desc, '确认提交批量拆网?', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.submitLoading = true
        // 构造提交参数:
        //   每个组网号携带勾选结果 (1=拆 / 0=不拆)
        const list = ready.map(item => ({
          groupNo: item.groupNo,
          ydFlag: item.unpackYd ? '1' : '0',
          dxFlag: item.unpackDx ? '1' : '0',
          remark: item.remark || ''
        }))
        // 先尝试走批量接口;若后端尚未支持 items 数组的格式,会在 catch 中降级到单条循环调用
        batchUnpackCardMultiCard({ items: list })
          .then(res => {
            if (res.data && res.data.code === 200) {
              this.$message.success(`批量拆网已提交,请到组网列表查看`)
              // 关闭当前标签页后跳转
              this.$store.dispatch('tagsView/delView', this.$route).then(() => {
                this.$router.push({ path: '/device/card/multiNet' })
              })
              this.submitLoading = false
            } else {
              this.$message.error((res.data && res.data.message) || '提交失败')
            }
          })
          .catch(() => {
            this.$message.error('批量拆网提交失败')
            this.submitLoading = false
          })
      })
      .catch(() => {})
    },

    /**
     * 表格 rowClassName
     */
    rowClassName({ row }) {
      return this.errorMap[row.groupNo] ? 'error-row' : ''
    },

    /**
     * 跳转组网详情
     */
    goGroupDetail(groupNo) {
      if (!groupNo) return
      this.$router.push({ path: '/card/multiNet/info', query: { groupNo } })
    },

    /**
     * 跳转卡详情
     */
    goCardDetail(iccid) {
      if (!iccid) return
      this.$router.push({ path: '/card/detail', query: { iccid } })
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-net-unpack-page {
  padding: 16px;
  background: #f0f2f5;
  min-height: 100%;
  padding-bottom: 80px;

  // 弹窗底部按钮居中
  ::v-deep .el-dialog__footer {
    text-align: center;

    .dialog-footer {
      display: inline-block;
    }
  }

  .page-body {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    min-height: calc(100vh - 220px);

    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #ebeef5;

      .header-text {
        .page-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          display: flex;
          align-items: center;

          .title-icon {
            color: #409eff;
            margin-right: 8px;
            font-size: 18px;
          }
        }
        .page-subtitle {
          margin-top: 6px;
          font-size: 13px;
          color: #606266;
          line-height: 1.6;
          .text-muted {
            color: #909399;
          }
        }
      }
      .header-actions {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
      }
    }

    .data-table {
      ::v-deep tr.error-row td {
        background-color: #fef0f0 !important;
      }
    }

    .add-card-bar {
      margin-top: 16px;
    }
  }

  .empty-state {
    background: #fff;
    border-radius: 4px;
    padding: 80px 20px;
    text-align: center;
    color: #909399;

    .empty-icon {
      font-size: 64px;
      color: #c0c4cc;
      margin-bottom: 16px;
    }
    .empty-title {
      font-size: 16px;
      color: #303133;
      margin-bottom: 8px;
    }
    .empty-desc {
      font-size: 13px;
      line-height: 1.7;
      margin-bottom: 24px;
      max-width: 480px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .page-footer {
    position: fixed;
    right: 0;
    bottom: 0;
    width: calc(100% - 200px);
    height: 60px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
    z-index: 100;

    .footer-summary {
      display: flex;
      gap: 24px;
      color: #606266;
      font-size: 14px;
      strong {
        color: #303133;
        font-size: 16px;
        margin: 0 4px;
      }
      .text-warn strong {
        color: #f56c6c;
      }
      .text-muted strong {
        color: #909399;
      }
    }

    // 按钮组相对整个底部栏绝对定位水平居中
    .footer-buttons {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

/* 单行:运营商图标 + 链接 */
.op-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.op-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
}
.op-icon-mobile {
  background: #00b060;
  &::after {
    content: 'M';
    position: absolute;
    inset: 0;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    font-weight: 600;
    font-style: normal;
  }
}
.op-icon-telecom {
  background: #005bac;
  &::after {
    content: 'T';
    position: absolute;
    inset: 0;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    font-weight: 600;
    font-style: normal;
  }
}

.add-stat {
  text-align: right;
  color: #606266;
  font-size: 13px;
  margin-top: 8px;
  strong {
    color: #409eff;
    margin: 0 2px;
  }
}

.placeholder {
  color: #c0c4cc;
}

.danger-text-btn {
  color: #f56c6c;
  &:hover {
    color: #f78989;
  }
}

@media (max-width: 768px) {
  .multi-net-unpack-page {
    .page-body .page-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      .header-actions {
        width: 100%;
      }
    }
    .page-footer {
      width: 100%;
      flex-direction: column;
      height: auto;
      padding: 12px;
      gap: 10px;
    }
  }
}
</style>